import { render, staticRenderFns } from "./Dot.vue?vue&type=template&id=1d470fcb&scoped=true"
import script from "./Dot.vue?vue&type=script&lang=js"
export * from "./Dot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d470fcb",
  null
  
)

export default component.exports